<template>
  <div class="about-main slide-item">
    <div class="slide-content">
      <div class="title">
        联系我们
        <div class="line"></div>
      </div>

      <div class="slid-map" style="margin: 20px 0;">
        <!-- <img class="map-img animated backInLeft" src="/image/image/map.fcc44c4.jpg" alt=""> -->
        <div class="about-us animated backInRight">
          <div class="row"><img src="/image/image/tel.png" alt=""> 代经理 15725805558</div>
          <!-- <div class="row"><img src="/image/image/email.png" alt="">Email:zhongshengwool@163.com</div> -->
          <div class="row"><img src="/image/image/addr.png" alt="">地址: 山东省淄博市沂源县县城</div>
          <div class="row">COPYRIGHT © 2019.</div>
          <div class="row">鲁ICP备2021018141号</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style scoped>
</style>